import React from 'react';
import NavBar from '../../components/NavBar/NavBar';

const DriverInfo: React.FC = () => {
    return (
        <>
            <NavBar />
            <div className={'main'}>
                <h1>Driver Information</h1>
                <p>This page will display information about drivers and performance metrics.</p>
            </div>
        </>
    );
}

export default DriverInfo;